@if (isLoginPage) {
<div style="width: 100%; height: 100%;">
    <router-outlet></router-outlet>
</div>
} @else {
<nz-layout class="app-layout">
    <nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
        [nzTrigger]="logoutBtn">
        <div class="sidebar-logo" [class.collapsed]="isCollapsed" (click)="isCollapsed = !isCollapsed">
            <img src="nova.svg" alt="Nova" class="sidebar-logo-img" />
            @if (!isCollapsed) { <h1>MEMO NOVA</h1> }
        </div>
        <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/dashboard">
                    <span nz-icon nzType="dashboard"></span>
                    <span>Dashboard General</span>
                </a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/ingresos">
                    <span nz-icon nzType="wallet"></span>
                    <span>Cortes de Caja</span>
                </a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/egresos">
                    <span nz-icon nzType="file-text"></span>
                    <span>Facturas (Egresos)</span>
                </a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/conciliacion">
                    <span nz-icon nzType="swap"></span>
                    <span>Conciliación Bancaria</span>
                </a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/pagos">
                    <span nz-icon nzType="calendar"></span>
                    <span>Programación de Pagos</span>
                </a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/efectivo">
                    <span nz-icon nzType="dollar-circle"></span>
                    <span>Efectivo y Dividendos</span>
                </a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/informes">
                    <span nz-icon nzType="bar-chart"></span>
                    <span>Informes Financieros</span>
                </a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/sass">
                    <span nz-icon nzType="shop"></span>
                    <span>Ventas SASS</span>
                </a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/catalogos">
                    <span nz-icon nzType="setting"></span>
                    <span>Catálogos y Config.</span>
                </a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/alertas">
                    <span nz-icon nzType="bell"></span>
                    <span>Motor de Alertas
                        @if (alertaService.unreadCount() > 0) {
                            <em class="nav-badge">{{ alertaService.unreadCount() }}</em>
                        }
                    </span>
                </a>
            </li>
            @if (backendService.isAdmin()) {
                <li nz-menu-item nzMatchRouter>
                    <a routerLink="/usuarios">
                        <span nz-icon nzType="team"></span>
                        <span>Control de Usuarios</span>
                    </a>
                </li>
            }
            @if (!isProduction && backendService.isOwner()) {
                <li nz-menu-divider></li>
                <li nz-menu-item nzMatchRouter>
                    <a routerLink="/dev">
                        <span nz-icon nzType="tool"></span>
                        <span>Dev Panel</span>
                    </a>
                </li>
            }
        </ul>

        <div class="user-profile user-profile-link" [class.collapsed]="isCollapsed"
             routerLink="/perfil" title="Mi cuenta">
            <div class="user-profile-avatar">
                {{ (username || 'U').charAt(0).toUpperCase() }}
            </div>
            <span *ngIf="!isCollapsed" class="user-name" [title]="username">{{ username || 'Usuario' }}</span>
        </div>
    </nz-sider>

    <ng-template #logoutBtn>
        <div class="logout-trigger" (click)="logout()">
            <span nz-icon nzType="logout"></span>
            <span *ngIf="!isCollapsed" class="logout-text">Cerrar Sesión</span>
        </div>
    </ng-template>

    <nz-layout class="right-layout">
        <nz-header class="app-header">
            <div class="header-right">
                <span class="connection-dot"
                      [class.offline]="backendService.backendOffline()"
                      [title]="backendService.backendOffline() ? 'Fuera de línea' : 'En línea'"
                      nz-tooltip
                      [nzTooltipTitle]="backendService.backendOffline() ? 'Fuera de línea' : 'En línea'"
                      nzTooltipPlacement="bottom"></span>
                <span class="header-date">{{ currentDate | date: 'EEEE, d MMMM y' : '' : 'es'}}</span>
                @if (uploadTracker.isUploading() || uploadTracker.hasCompletedUnread()) {
                    <div class="upload-wrapper">
                        <div class="upload-indicator" (click)="toggleUploadPanel($event)">
                            @if (uploadTracker.isUploading()) {
                                <app-spinner inline size="sm" [respectOffline]="false" />
                            } @else {
                                <span nz-icon [nzType]="uploadTracker.completedUploads().at(-1)?.tipo === 'descarga' ? 'cloud-download' : 'cloud-upload'" class="upload-icon upload-done"></span>
                            }
                            @if (uploadTracker.activeCount() > 0) {
                                <span class="upload-badge">{{ uploadTracker.activeCount() }}</span>
                            }
                        </div>
                        @if (showUploadPanel) {
                            <div class="upload-panel">
                                <div class="upload-panel-header">
                                    <span class="upload-panel-title">Transferencias</span>
                                    @if (uploadTracker.completedUploads().length > 0) {
                                        <span class="upload-clear-btn" (click)="uploadTracker.dismissAllCompleted()">Limpiar</span>
                                    }
                                </div>
                                <div class="upload-panel-body">
                                    @for (u of uploadTracker.activeUploads(); track u.id) {
                                        <div class="upload-item uploading">
                                            <div class="upload-item-left">
                                                <span class="upload-item-origin">{{ originLabel(u.origin) }}</span>
                                                @if (u.tipo === 'descarga') {
                                                    <span nz-icon nzType="cloud-download" class="upload-item-status-icon"></span>
                                                }
                                                <app-spinner inline size="sm" [respectOffline]="false" />
                                            </div>
                                            <span class="upload-item-detail">
                                                @if (u.tipo === 'descarga') { {{ u.fileNames[0] }} } @else { {{ u.fileNames.length }} archivo(s) }
                                            </span>
                                        </div>
                                    }
                                    @for (c of uploadTracker.completedUploads(); track c.id) {
                                        <div class="upload-item" [class.upload-success]="c.success" [class.upload-error]="!c.success">
                                            <div class="upload-item-left">
                                                <span class="upload-item-origin">{{ originLabel(c.origin) }}</span>
                                                @if (c.tipo === 'descarga') {
                                                    <span nz-icon nzType="cloud-download" class="upload-item-status-icon"></span>
                                                }
                                                <span nz-icon [nzType]="c.success ? 'check-circle' : 'close-circle'" class="upload-item-status-icon"></span>
                                                <span nz-icon nzType="close" class="upload-dismiss" (click)="uploadTracker.dismissCompleted(c.id)"></span>
                                            </div>
                                            <span class="upload-item-detail">{{ c.message }}</span>
                                        </div>
                                    }
                                    @if (uploadTracker.activeUploads().length === 0 && uploadTracker.completedUploads().length === 0) {
                                        <div class="upload-empty">Sin archivos en proceso</div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
                <div class="notification-wrapper">
                    <span
                        nz-icon nzType="bell" nzTheme="outline"
                        class="header-icon"
                        (click)="toggleNotifications($event)">
                    </span>
                    @if (alertaService.hasUnread()) {
                        <span class="notification-badge"></span>
                    }
                    @if (showNotifications) {
                        <div class="notification-panel">
                            <div class="notification-panel-header">
                                <span class="notification-panel-title">Alertas</span>
                                @if (alertaService.hasUnread()) {
                                    <span class="notification-mark-all" (click)="markAllRead()">Marcar todas como leídas</span>
                                }
                            </div>
                            <div class="notification-panel-body">
                                @for (grupo of alertaService.resumen(); track grupo.tipo) {
                                    <div
                                        class="notification-item"
                                        [class.unread]="grupo.no_leidas > 0"
                                        (click)="goToTipoAlerta(grupo.tipo)">
                                        <div class="notification-item-dot" [attr.data-type]="grupo.severidad"></div>
                                        <div class="notification-item-content">
                                            <span class="notification-item-title">{{ alertaTipoLabel(grupo.tipo) }}</span>
                                            <span class="notification-item-message">
                                                {{ grupo.total }} en total@if (grupo.no_leidas > 0) {, {{ grupo.no_leidas }} sin leer}
                                            </span>
                                        </div>
                                        <span class="notification-item-count">{{ grupo.total }}</span>
                                    </div>
                                } @empty {
                                    <div class="notification-empty">No hay alertas pendientes</div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </nz-header>
        @for (orphan of orphanedUploads; track $index) {
            <div class="orphan-banner" [class.orphan-completed]="orphan.status === 'completed'"
                 [class.orphan-partial]="orphan.status === 'partial'"
                 [class.orphan-interrupted]="orphan.status === 'interrupted'">
                @if (orphan.status === 'completed') {
                    <span nz-icon nzType="check-circle" class="orphan-icon"></span>
                    <span>{{ originLabel(orphan.origin) }}: archivos procesados exitosamente antes del reinicio.</span>
                } @else if (orphan.status === 'partial') {
                    <span nz-icon nzType="warning" class="orphan-icon"></span>
                    <span>{{ originLabel(orphan.origin) }}: {{ orphan.found.length }} de {{ orphan.fileNames.length }} archivo(s) se procesaron. Vuelve a subir los faltantes.</span>
                } @else {
                    <span nz-icon nzType="close-circle" class="orphan-icon"></span>
                    <span>{{ originLabel(orphan.origin) }}: la carga se interrumpió. Vuelve a subir los archivos.</span>
                }
                <span nz-icon nzType="close" class="orphan-close" (click)="dismissOrphaned()"></span>
            </div>
        }
        <nz-content>
            <div class="inner-content">
                <router-outlet></router-outlet>
            </div>
        </nz-content>
    </nz-layout>
</nz-layout>

<!-- Confirmación de cierre de sesión -->
<app-modal title="Cerrar sesión" size="sm" [isOpen]="showLogoutConfirm" (closed)="showLogoutConfirm = false">
    <p class="logout-confirm-text">¿Seguro que quieres cerrar tu sesión?</p>
    <div modalFooter class="logout-actions">
        <button class="logout-cancel-btn" type="button" (click)="showLogoutConfirm = false">Cancelar</button>
        <button class="logout-confirm-btn" type="button" (click)="confirmLogout()">
            <span nz-icon nzType="logout"></span> Cerrar sesión
        </button>
    </div>
</app-modal>

<!-- Onboarding: configuración inicial del sistema (solo ADMIN, si no está configurado) -->
<app-modal title="Configura el arranque del sistema" size="sm" [isOpen]="showConfigSetup"
           (closed)="showConfigSetup = false">
    <p class="logout-confirm-text">
        Aún no defines desde qué mes arranca el sistema ni el saldo inicial. Configúralo para que el
        flujo de efectivo calcule y encadene los saldos correctamente.
    </p>
    <app-config-sistema-form [(mes)]="cfgMes" [(anio)]="cfgAnio" [(saldo)]="cfgSaldo" />
    <div modalFooter class="logout-actions">
        <button class="logout-cancel-btn" type="button" (click)="showConfigSetup = false">Más tarde</button>
        <button class="logout-confirm-btn" type="button" [disabled]="savingConfig"
                (click)="guardarConfigSetup()">
            <span nz-icon nzType="save"></span>
            {{ savingConfig ? 'Guardando…' : 'Guardar configuración' }}
        </button>
    </div>
</app-modal>

<!-- OBLIGATORIO: estados de cuenta sin mes determinable. No se puede cerrar
     hasta definir el mes de cada uno; reaparece al recargar porque el
     pendiente vive en el servidor. -->
<app-modal title="Estados de cuenta sin mes definido" size="lg" [blocking]="true"
           [isOpen]="showPeriodoModal" (closed)="showPeriodoModal = false">
    <p class="logout-confirm-text">
        Estos estados de cuenta tienen movimientos sin fecha y no fue posible detectar de qué mes
        son. Define el mes de cada uno — sin esto, sus movimientos no entran a la conciliación ni
        a los reportes y el flujo del sistema queda incompleto.
    </p>
    @for (p of pendientesPeriodo; track p.estado_cuenta_id) {
        <div class="periodo-row">
            <div class="periodo-info">
                <div class="periodo-archivo">
                    <span nz-icon nzType="file-pdf"></span>
                    {{ p.archivo_nombre || 'Estado de cuenta #' + p.estado_cuenta_id }}
                </div>
                <div class="periodo-meta">
                    {{ p.banco }} · {{ p.numero_cuenta }} ·
                    <strong>{{ p.omitidos }}</strong> movimiento(s) sin fecha
                    @if (p.fecha_subida) {
                        · subido el {{ p.fecha_subida | date:'dd/MM/yyyy' }}
                    }
                </div>
            </div>
            <div class="periodo-controls">
                <select class="periodo-select" [(ngModel)]="periodoSel[p.estado_cuenta_id].mes"
                        [attr.aria-label]="'Mes del estado ' + p.estado_cuenta_id">
                    <option [ngValue]="null" disabled>Mes</option>
                    @for (m of mesesPeriodo; track m.v) {
                        <option [ngValue]="m.v">{{ m.label }}</option>
                    }
                </select>
                <select class="periodo-select" [(ngModel)]="periodoSel[p.estado_cuenta_id].anio"
                        [attr.aria-label]="'Año del estado ' + p.estado_cuenta_id">
                    <option [ngValue]="null" disabled>Año</option>
                    @for (a of aniosPeriodo; track a) {
                        <option [ngValue]="a">{{ a }}</option>
                    }
                </select>
                <button class="btn-primary" type="button"
                        [disabled]="periodoSel[p.estado_cuenta_id].mes == null
                                    || periodoSel[p.estado_cuenta_id].anio == null
                                    || savingPeriodo[p.estado_cuenta_id]"
                        (click)="guardarPeriodo(p.estado_cuenta_id)">
                    <span nz-icon nzType="save"></span>
                    {{ savingPeriodo[p.estado_cuenta_id] ? 'Guardando…' : 'Guardar' }}
                </button>
            </div>
        </div>
    }
</app-modal>
}
